module.exports = __webpack_public_path__ + "img/miten-asuisit-mieluiten.54eae4e2.jpg";